export default "__VITE_ASSET__Cnghw4nj__"